import React, { Component } from "react";
import { MessageBox } from "react-chat-elements";
import { Image } from "antd";

class ImageMessageBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { msg, fetchUserFile, dateFormatter } = this.props;

    return (
      <div>
        <MessageBox
          position={msg.owner === "client" ? "left" : "right"}
          title={msg.owner === "client" ? undefined : msg.owner}
          type={"text"}
          onDownload={async () => await fetchUserFile(msg.file_id, msg.id)}
          text={
            msg.file ?
              <div style={{ textAlign: msg.owner === "client" ? "left" : "right" }}>
                <Image
                  width={300}
                  height={200}
                  src={msg.file}
                  alt="message-img"
                  style={{ borderRadius: 8 }}
                />
              </div>
              :
              <div
                style={{
                  cursor: "pointer",
                  width: "300px",
                  height: "200px",
                  backgroundColor: "rgba(0,0,0,.5)",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={async () => await fetchUserFile(msg.file_id, msg.id)}
              >
                <button style={{
                  fontSize: "3.2em",
                  color: "#efe",
                  border: "1px solid #eee",
                  borderRadius: "100%",
                  height: "100px",
                  width: "100px",
                  background: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}>
                  <svg
                    fill="#fff"
                    preserveAspectRatio="xMidYMid meet"
                    height="1em"
                    width="1em"
                    viewBox="0 0 40 40"
                    style={{ verticalAlign: "middle" }}
                  >
                    <g>
                      <path d="M26.6 20.7q0-0.3-0.2-0.5t-0.5-0.2h-4.6v-7.3q0-0.3-0.2-0.5t-0.5-0.2h-4q-0.3 0-0.5 0.2t-0.2 0.5v7.3h-4.6q-0.3 0-0.5 0.2t-0.2 0.5q0 0.3 0.2 0.4l7.3 7.4q0.2 0.1 0.5 0.1t0.5-0.1l7.3-7.3q0.2-0.3 0.2-0.5z M39.9 25.3q0 3.3-2.4 5.7t-5.6 2.3H9.3q-3.8 0-6.6-2.7t-2.7-6.6q0-2.7 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.5-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.6-0.8 2.8 2.7 0.7 4.4 2.9t1.8 4.9z"></path>
                    </g>
                  </svg>
                </button>
              </div>
          }
          dateString={dateFormatter(msg.timestamp)}
          className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
        />


        {msg.content && msg.content.length > 0 && (
          <MessageBox
            position={msg.owner === "client" ? "left" : "right"}
            title={msg.owner === "client" ? undefined : msg.owner}
            type={"text"}
            text={
              msg.content
                ? msg.content.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))
                : ""
            }
            dateString={dateFormatter(msg.timestamp)}
            className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
          />
        )}
      </div>
    );
  }
}

export default ImageMessageBox;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/ImageMessageBox.jsx